export default __webpack_public_path__ + "static/media/bg-bottom.2b17c152.webp";